import { useIntl } from "react-intl";

export const QuestionsTranslationWrapper = (props) => {
  const intl = useIntl();
  const translatedProps = {};

  const translate = (thing) => {
    if (!thing) return thing;
    return intl.formatMessage({
      id: thing,
      defaultMessage: thing,
      description: "",
    });
  };

  const translatePlainText = (plainTextObj) => {
    return {
      ...plainTextObj,
      value: translate(plainTextObj.value),
      placeholders:
        plainTextObj.placeholders &&
        Object.keys(plainTextObj.placeholders).length > 0
          ? Object.keys(plainTextObj.placeholders).reduce((acc, key) => {
              acc[key] = translatePlainText(plainTextObj.placeholders[key]);
              return acc;
            }, {}) // Providing an initial value (empty object) for the reduce function
          : plainTextObj.placeholders, // Handle case where placeholders is empty or undefined
    };
  };

  const translateProp = (prop) => {
    if (!prop) return prop;
    return typeof prop === "string"
      ? translate(prop)
      : translatePlainText(prop);
  };

  for (const key of Object.keys(props)) {
    switch (key) {
      case "question":
        translatedProps.question = translateProp(props.question);
        break;

      case "text":
        translatedProps.text = translateProp(props.text);
        break;

      case "correctFeedback":
        translatedProps.correctFeedback = translateProp(props.correctFeedback);
        break;

      case "incorrectFeedback":
        translatedProps.incorrectFeedback = translateProp(
          props.incorrectFeedback
        );
        break;

      case "buttonText":
        translatedProps.buttonText = translateProp(props.buttonText);
        break;

      case "figcaption":
        translatedProps.figcaption = {
          ...props.figcaption,
          caption: translateProp(props.figcaption.caption),
          altText: translateProp(props.figcaption.altText),
        };
        break;

      case "image":
        translatedProps.image = {
          ...props.image,
          caption: translateProp(props.image.caption),
          altText: translateProp(props.image.altText),
        };
        break;

      case "hintDetails":
        translatedProps.hintDetails = {
          ...props.hintDetails,
          label: translateProp(props.hintDetails.label),
          content: translateProp(props.hintDetails.content),
        };
        break;

      case "feedback":
        if (props.feedback.SUCCESS_MESSAGE && props.feedback.FAIL_MESSAGE) {
          translatedProps.feedback = {
            ...props.feedback,
            SUCCESS_MESSAGE: translateProp(props.feedback.SUCCESS_MESSAGE),
            FAIL_MESSAGE: translateProp(props.feedback.FAIL_MESSAGE),
          };
        } else {
          translatedProps.feedback = translateProp(props.feedback);
        }
        break;

      case "dataTable":
        translatedProps.dataTable = {
          ...props.dataTable,
          indices: props.dataTable.indices,
          data: props.dataTable.data.map((row) =>
            row.map((cell) => {
              return {
                ...cell,
                text: translateProp(cell.text),
              };
            })
          ),
        };
        break;

      case "data":
        translatedProps.data = props.data.map((row) =>
          row.map((cell) => {
            return {
              ...cell,
              text: translateProp(cell.text),
              placeholder: translateProp(cell.placeholder),
            };
          })
        );
        break;

      case "options":
        switch (props.type) {
          case "COLOR_PREDICTION":
            translatedProps.options = props.options.map((option) => {
              return {
                ...option,
                checkboxes: option.checkboxes.map((checkbox) => {
                  return {
                    ...checkbox,
                    label: translateProp(checkbox.label),
                  };
                }),
              };
            });
            break;
          default:
            translatedProps.options = props.options.map((option) => {
              return {
                ...option,
                text: translateProp(option.text),
                feedback: translateProp(option.feedback),
              };
            });
            break;
        }
        break;

      case "checkboxes":
        switch (props.type) {
          case "COLOR_PREDICTION":
            translatedProps.options = props.options.map((option) => {
              return {
                ...option,
                checkboxes: option.checkboxes.map((checkbox) => {
                  return {
                    ...checkbox,
                    label: translateProp(checkbox.label),
                  };
                }),
              };
            });
            break;
          default:
            translatedProps.checkboxes = props.checkboxes.map((option) => {
              return {
                ...option,
                text: translateProp(option.text),
                feedback: translateProp(option.feedback),
              };
            });
            break;
        }
        break;

      case "altText":
        translatedProps.altText = translateProp(props.altText);
        break;
      case "ariaLabel":
        translatedProps.ariaLabel = translateProp(props.ariaLabel);
        break;
      default:
        translatedProps[key] = props[key];
        break;
    }
  }
  return translatedProps;
};
